import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { UpsertUserPermissionRequest } from './types/upsert-user-permission-request.type';

/**
 * Grants a permission directly to a user.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param uid - Unique identifier of the user.
 * @param body - The permission grant, including the effective and expiration dates.
 * @returns OperationResult (no payload).
 */
export const upsertUserPermission = async (instance: KyInstance, uid: string, body: UpsertUserPermissionRequest) => {
  try {
    return await instance
      .post<OperationResult>(formatString(Uri.users.permissions, uid), {
        json: body,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
